export const QUERY_KEYS = {
  BIOFLUX_MASTERS: 'bioflux-masters',
  PENDING_ACTIONS: 'pending-actions',
  ACTIVE_COMPANIES: 'active-companies',
  COMPANY_DETAILS: 'company-details',
  CONSUMER_TABLE: 'consumer-table',
  CONSUMER_CHART: 'consumer-chart',
};
